import { createSelector } from '@reduxjs/toolkit';
import selectEnvironmentConfig from './selectEnvironmentConfig';

export default createSelector(selectEnvironmentConfig, (env) => env?.playerUrl);
